export const TIME_OUT = 60000;
export const BASE_URL = "/api";
